//@ts-nocheck
import React from 'react';
import colors from '../../css/colors';

const cityBarWrap = {
  backgroundColor: colors.grey600,
  borderRadius: 5,
  display: 'flex',
  marginTop: 20,
  padding: '0 16px',
  position: 'relative',
  minWidth: 552.85,
  justifyContent: 'flex-start',
  height: 48,
};

const cellWrap = {
  display: 'inline-flex',
  justifyContent: 'center',
  flexDirection: 'column',
  fontFamily: 'IBM Plex Sans',
  gap: 3,
  minWidth: 134,
  ' span': { color: colors.grey300 },
};

export default function SelectedCityBar({ city, icon }) {
  const { county, municipality, municipalityType, subMunicipality, subMunicipalityType, swisCode, stateCode, hamletName } = city;
  return (
    <div style={cityBarWrap}>
      <div style={{ marginRight: 16, cursor: 'pointer' }}>{icon}</div>
      <div style={cellWrap}>
        <span style={{ textTransform: 'uppercase', fontSize: 11 }}>State</span>
        {stateCode}
      </div>
      <div style={cellWrap}>
        <span style={{ textTransform: 'uppercase', fontSize: 11 }}>County</span>
        {county}
      </div>
      <div style={cellWrap}>
        <span style={{ textTransform: 'uppercase', fontSize: 11 }}>{municipalityType}</span>
        {municipality}
      </div>
      {subMunicipalityType && (
        <div style={cellWrap}>
          <span style={{ textTransform: 'uppercase', fontSize: 11 }}>{subMunicipalityType}</span>
          {subMunicipality}
        </div>
      )}
      {hamletName && (
        <div style={cellWrap}>
          <span style={{ textTransform: 'uppercase', fontSize: 11 }}>Hamlet</span>
          {hamletName}
        </div>
      )}
      {swisCode && (
        <div style={cellWrap}>
          <span style={{ textTransform: 'uppercase', fontSize: 11 }}>Swis Code</span>
          {swisCode}
        </div>
      )}
    </div>
  );
}
